import { GitPush400ErrorPayload } from '../util/git-push-error/models/dbt.model';
import { GitErrorStatusCode } from './errors.enum';
import { GitPushError } from './git-push.git-error';

/**
 * Thrown when `git push` failed, due to malformed file.
 */
export class GitPushClientError extends GitPushError {
  readonly gitErrorCode = GitErrorStatusCode.GitPushClient;
  body!: GitPush400ErrorPayload;
}
